// Small DOM helpers. The panels update every frame, so setters only touch the
// DOM when a value actually changes -- that keeps layout work down and leaves
// buttons in place under the pointer (rebuilding them mid-click drops clicks).

export const $ = (selector, root = document) => root.querySelector(selector);

export function setText(el, value) {
  const v = String(value);
  if (el.textContent !== v) el.textContent = v;
}

export function setClass(el, className) {
  if (el.className !== className) el.className = className;
}

export function setHidden(el, hidden) {
  if (el.hidden !== hidden) el.hidden = hidden;
}

export function setHTML(el, html) {
  if (el._html !== html) { el.innerHTML = html; el._html = html; }
}

/**
 * Keep a container's children in sync with a list of items, one element per
 * item id, created once and updated in place, in the given order.
 */
export function syncList(container, cache, items, create, update) {
  const seen = new Set();
  items.forEach((item, i) => {
    let el = cache.get(item.id);
    if (!el) { el = create(item); cache.set(item.id, el); }
    seen.add(item.id);
    update(el, item);
    if (container.children[i] !== el) container.insertBefore(el, container.children[i] || null);
  });
  for (const [id, el] of cache) {
    if (!seen.has(id)) { el.remove(); cache.delete(id); }
  }
}
